import getByIdPropReduxSelector from '../../../../redux/selectors/get-by-id-prop'
import WORKOUTS_PATH from '../../constants/path'
import getRecommendedByIdWorkoutSelector from '../get-recommended-by-id'

function getByIdWorkoutSelector (id) {
  return (state) => {
    return (
      getByIdPropReduxSelector(WORKOUTS_PATH.DATA)(state, { id }) ||
      getRecommendedByIdWorkoutSelector(id)(state)
    )
  }
}

export default getByIdWorkoutSelector
